module.exports = __webpack_public_path__ + "static/media/document.167ebd34.svg";